export const getSingleExpenseEntry = async (dataHouse, orderId) => {
  const singleOrderDetails = await dataHouse.find((data) => {
    return data.id === orderId;
  });
  return singleOrderDetails;
};
